/* node_Modules */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

/* local imports */
import FormattedMessage from '~/components/common/FormattedMessage';
import PremiumButton from '~/components/Button/Premium';
import PremiumTable from '~/components/Premium/Table';

/* style imports */
import styles from './Premium.scss';

const cx = classNames.bind(styles);

class PremiumRow extends Component {
  render() {
    const isSplit = this.props.image || this.props.icon;

    const className = cx('PremiumPageRow', {
      'PremiumPageRow--divider': this.props.divider,
      'PremiumPageRow--split': isSplit,
    });

    if (isSplit) {
      return (
        <div className={className}>
          <div className={cx('PremiumPageRow__Image')}>
            {this.props.image && <img src={this.props.image} />}
            {this.props.icon && <i className={`icon ${this.props.icon}`} />}
          </div>
          <div className={cx('PremiumPageRow__Text')}>{this.props.children}</div>
        </div>
      );
    }

    return <div className={className}>{this.props.children}</div>;
  }
}

export class Premium extends Component {
  render() {
    const className = cx('PremiumPage');

    return (
      <div className={className}>
        <PremiumRow divider>
          <h1>
            <FormattedMessage
              id="PremiumPage_Heading"
              defaultMessage="Piczel.tv Premium"
            />
          </h1>
          <p>
            <FormattedMessage
              id="PremiumPage_Paragraph"
              defaultMessage="Lots of extra features for $10/month."
            />
          </p>
          {this.props.isSignedIn ? (
            <p>
              <FormattedMessage
                id="PremiumButton_SupportUsPremium"
                defaultMessage="Support us on patreon to receive premium access"
              />
              <PremiumButton to="https://patreon.com/piczeltv" />
            </p>
          ) : (
            <Link to="/signup">
              <FormattedMessage
                id="PremiumPage_SignUp"
                defaultMessage="Sign up"
              />
            </Link>
          )}
        </PremiumRow>
        <PremiumRow icon="ion-grid">
          <h2>
            <FormattedMessage
              id="PremiumPage_MultiRow_Heading"
              defaultMessage="Multistreams / views"
            />
          </h2>
          <FormattedMessage
            id="PremiumPage_MultiRow_Text"
            defaultMessage="Go live with your friends in multistreams with up to 16 members - all your streams appear on the same page with a shared chat. As a viewer, open as many streams on one page as you like."
          />
        </PremiumRow>
        <PremiumRow icon="ion-images">
          <h2>
            <FormattedMessage
              id="PremiumPage_Gallery_Heading"
              defaultMessage="Bigger gallery"
            />
          </h2>
          <FormattedMessage
            id="PremiumPage_Gallery_Text"
            defaultMessage="Expand your Piczel.tv gallery with unlimited images and bigger filesizes."
          />
        </PremiumRow>
        <PremiumRow icon="ion-ios-email">
          <h2>
            <FormattedMessage
              id="PremiumPage_EmailAnnounce_Heading"
              defaultMessage="Email announcements"
            />
          </h2>
          <FormattedMessage
            id="PremiumPage_EmailAnnounce_Text"
            defaultMessage="Send custom announcements to all your followers whenever and however you want."
          />
        </PremiumRow>
        <PremiumRow icon="ion-star">
          <h2>
            <FormattedMessage
              id="PremiumPage_Customize_Heading"
              defaultMessage="Customize your stream"
            />
          </h2>
          <FormattedMessage
            id="PremiumPage_Customize_Text"
            defaultMessage="Upload chat emotes for everyone to use in your chatroom or a banner displayed on your page."
          />
        </PremiumRow>
        <PremiumRow icon="ion-videocamera">
          <h2>
            <FormattedMessage
              id="PremiumPage_Recording_Heading"
              defaultMessage="Recording"
            />
          </h2>
          <FormattedMessage
            id="PremiumPage_Recording_Text"
            defaultMessage="Record your stream and let your followers download and watch it whenever they want to. Or just keep it to yourself."
          />
        </PremiumRow>
        <PremiumRow icon="ion-locked" divider>
          <h2>
            <FormattedMessage
              id="PremiumPage_Private_Heading"
              defaultMessage="Private streams"
            />
          </h2>
          <FormattedMessage
            id="PremiumPage_Private_Text"
            defaultMessage="Protect your stream with a password, so only those permitted to watch get access."
          />
        </PremiumRow>
        <PremiumRow>
          <PremiumTable />
          {this.props.isSignedIn ? (
            <Link to="/account/patreon">
              <FormattedMessage
                id="PremiumPage_Buy"
                defaultMessage="Buy premium"
              />
            </Link>
          ) : (
            <Link to="/signup">
              <FormattedMessage
                id="PremiumPage_SignUp"
                defaultMessage="Sign up"
              />
            </Link>
          )}
        </PremiumRow>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isSignedIn: state.currentUser.isSignedIn,
    currentUser: state.currentUser.data,
  };
}

export default connect(mapStateToProps)(Premium);
